var map = {
	"./arrow-right.svg": 6415,
	"./chevron-right.svg": 9501,
	"./icon-archive-arrow-left.svg": 7889,
	"./icon-archive-arrow-right.svg": 5852,
	"./icon-arrow-circle-right.svg": 7060,
	"./icon-arrow-long-right.svg": 3154,
	"./icon-chevron-back.svg": 7762,
	"./icon-chevron-circle-left.svg": 9483,
	"./icon-chevron-circle-right.svg": 8302,
	"./icon-chevron-down.svg": 1107,
	"./icon-close-white.svg": 8435,
	"./icon-cross-black.svg": 5365,
	"./icon-cross.svg": 9323,
	"./icon-download-black.svg": 9987,
	"./icon-download-white.svg": 3353,
	"./icon-edit-project.svg": 5173,
	"./icon-eye-black.svg": 4502,
	"./icon-eye.svg": 4860,
	"./icon-heart-black.svg": 4181,
	"./icon-heart.svg": 5051,
	"./icon-help-coordinates-1.svg": 2808,
	"./icon-help-coordinates-2.svg": 4699,
	"./icon-instagram-black.svg": 1905,
	"./icon-instagram-white.svg": 9959,
	"./icon-instagram.svg": 3159,
	"./icon-logout-black.svg": 3769,
	"./icon-mail.svg": 652,
	"./icon-map-marker-big.svg": 2717,
	"./icon-map-marker-black.svg": 730,
	"./icon-map-question.svg": 974,
	"./icon-map-zoom.svg": 3531,
	"./icon-nav-home.svg": 3296,
	"./icon-nav-insights.svg": 42,
	"./icon-nav-messages.svg": 7081,
	"./icon-nav-notifications.svg": 4471,
	"./icon-nav-projects.svg": 9555,
	"./icon-nav-upload.svg": 6850,
	"./icon-new-conversation.svg": 9475,
	"./icon-notification-approved.svg": 2708,
	"./icon-notification-commented.svg": 8335,
	"./icon-notification-liked.svg": 9724,
	"./icon-notification-rejected.svg": 8211,
	"./icon-notification-saved.svg": 8250,
	"./icon-plus-circle-black.svg": 4448,
	"./icon-project-mention.png": 9055,
	"./icon-question-append-desktop.svg": 1089,
	"./icon-search.svg": 1049,
	"./icon-selector-approve.svg": 8190,
	"./icon-selector-creador.svg": 4749,
	"./icon-selector-deny.svg": 3693,
	"./icon-selector-editar.svg": 5882,
	"./icon-selector-empresa.svg": 4048,
	"./icon-selector-estudiante.svg": 2483,
	"./icon-selector-institucional.svg": 6825,
	"./icon-selector-login.svg": 7446,
	"./icon-selector-otros.svg": 8394,
	"./icon-selector-pendant.svg": 2575,
	"./icon-selector-profesional.svg": 299,
	"./icon-selector-recomendado.svg": 960,
	"./icon-selector-redes-sociales.svg": 7780,
	"./icon-selector-trabajo.svg": 6336,
	"./icon-selector-ver-perfil.svg": 2017,
	"./icon-selector-ver-proyecto.svg": 7882,
	"./icon-send-white.svg": 4271,
	"./icon-send.svg": 6911,
	"./icon-share.svg": 1654,
	"./icon-star-black.svg": 3803,
	"./icon-star.svg": 4957,
	"./icon-wordpress-black.svg": 4992,
	"./icon-wordpress-white.svg": 4606,
	"./icon-youtube-black.svg": 234,
	"./icon-youtube-white.svg": 3648,
	"./icon-zoom-in.svg": 1648,
	"./icon-zoom-out.svg": 4095,
	"./show-more-circle-white.svg": 7107,
	"./swiper-chevron-left.svg": 7381,
	"./swiper-chevron-right.svg": 9272
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5853;